import { type UseScheduleActivationReturn } from '../hooks/useScheduleActivation';
import ConfigurationModal from '../../configuration/components/ConfigurationModal';
import ActivationModal from './ActivationModal';

interface Props {
  countryCode: string;
  activation: UseScheduleActivationReturn;
}

export default function ScheduleActivationModals({ countryCode, activation }: Props) {
  const {
    activationFlow,
    submitConfiguration,
    cancelActivation,
    backToConfigure,
    confirmActivation,
    completeActivation,
  } = activation;

  return (
    <>
      {activationFlow?.step === 'configure' && (
        <ConfigurationModal
          schedule={activationFlow.schedule}
          countryCode={countryCode}
          preferences={activationFlow.preferences}
          onClose={cancelActivation}
          onSubmit={submitConfiguration}
        />
      )}
      {activationFlow?.step === 'payment' && (
        <ActivationModal
          countryCode={countryCode}
          schedule={activationFlow.schedule}
          preferences={
            activationFlow.intent === 'reactivate' ? activationFlow.preferences : undefined
          }
          intent={activationFlow.intent}
          onClose={cancelActivation}
          onBack={backToConfigure}
          onConfirm={confirmActivation}
          onActivated={completeActivation}
        />
      )}
    </>
  );
}
